import app from '@/app';
import templateUrl from './allPlansByProject-search.html';

/* @ngInject */
function AllPlansByProjectController($controller, $state, AllPlansByProject, WarnIqdService, Principal) {
	var $ctrl = this;
	var resource = AllPlansByProject;
	$controller('AbstractPageSortController', { $ctrl: $ctrl });

	var transition = $ctrl.transition;

  $ctrl.currentAccount = null;
  
  Principal.identity().then(account => {
	$ctrl.currentAccount = account;
	})


	$ctrl.transition = params => {
		transition(params);

		$ctrl.road = $ctrl.allRoads.content.find(it => it.id == params.road);
		$ctrl.campaigns = _.flow(
			_.keyBy('id'),
			_.at(params.campaigns || [])
		)($ctrl.allCampaigns.content);
		resource.query(
			{
				road: params.road,
				sort: params.sort,
				page: params.page,
				size: params.size
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);
	};

	$ctrl.onOrganizationChange = organization => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
	};

	$ctrl.onRoadTypeChange = roadtype => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
	};

	$ctrl.byOrganization = value =>
		$ctrl.organization && value.organization.id == $ctrl.organization.id;

	$ctrl.byOwner = value => $ctrl.organization && value.owner.id == $ctrl.organization.id;

	$ctrl.onQueryChange = () => {
		$state.go(
			$state.current,
			{
				page: 0,
				road: $ctrl.road.id
			},
			{
				reload: true
			}
		);
	};

	$ctrl.remove = (id, name) => resource.remove({ id: id }, () => $state.reload()).$promise;
}

app.component('allPlansByProjectSearch', {
	templateUrl,
	controller: AllPlansByProjectController,
	bindings: {
		$transition$: '<',
		allOrganizations: '<',
		allRoads: '<',
		allCampaigns: '<',
		allDecisionTrees: '<',
		allCostTables: '<'
	}
});
